export default "__VITE_ASSET__CW7PpHm4__"